import { CometChatUIKit, UIKitSettingsBuilder } from '@cometchat/chat-uikit-react';
import { CometChat } from '@cometchat/chat-sdk-javascript';
import { COMETCHAT_CONFIG } from 'config/cometChatConfig';
import NotificationService from 'service/NotificationService';
import { getDeviceType, getOrCreateDeviceId, resolveDeviceToken } from 'library/helpers/device';
import { initFcmAndGetToken } from 'library/helpers/fcm';

/**
 * What the sign-in page does right after a successful OTP, for login flows that happen inside a
 * modal: saves the session, signs the user into chat and registers the device for notifications.
 * Chat and notification failures are swallowed — they must never block a login.
 */
export const completeLogin = async (jwtToken: string, userDetails: any): Promise<void> => {
  localStorage.setItem('jwtToken', jwtToken);
  localStorage.setItem('userDetails', JSON.stringify(userDetails));

  try {
    const UID = (userDetails?.id || '').toString();
    const name = `${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`.trim() || UID;
    if (UID) {
      const authKey = COMETCHAT_CONFIG.AUTH_KEY;
      try {
        const appSetting = new CometChat.AppSettingsBuilder()
          .subscribePresenceForAllUsers()
          .setRegion(COMETCHAT_CONFIG.REGION)
          .autoEstablishSocketConnection(true)
          .build();
        await CometChat.init(COMETCHAT_CONFIG.APP_ID, appSetting);
      } catch (_) {}
      try {
        const uiKitSettings = new UIKitSettingsBuilder()
          .setAppId(COMETCHAT_CONFIG.APP_ID)
          .setRegion(COMETCHAT_CONFIG.REGION)
          .setAuthKey(COMETCHAT_CONFIG.AUTH_KEY)
          .subscribePresenceForAllUsers()
          .build();
        await CometChatUIKit.init(uiKitSettings);
      } catch (_) {}
      const cometUser = new CometChat.User(UID);
      cometUser.setName(name);
      try {
        await CometChat.createUser(cometUser, authKey);
      } catch (createErr: any) {
        if (createErr?.code !== 'ERR_UID_ALREADY_EXISTS') {
          console.warn('CometChat createUser error:', createErr);
        }
      }
      try {
        await CometChat.login(UID, authKey);
      } catch (loginErr) {
        console.warn('CometChat SDK login error:', loginErr);
      }
      try {
        const u = await CometChatUIKit.getLoggedinUser();
        if (!u) {
          await CometChatUIKit.login(UID).catch(() => {});
        }
      } catch (_) {}
    }
  } catch (_) {}

  try {
    const freshToken = await initFcmAndGetToken().catch(() => null);
    NotificationService.registerDevice({
      deviceId: getOrCreateDeviceId(),
      deviceType: getDeviceType(),
      deviceToken: freshToken || resolveDeviceToken(),
    }).catch(() => {});
  } catch (_) {}
};
